export class GetChartDetail {
  static readonly type = '[Chart] GetChartDetail';
  constructor(public param: string) {}
}
